import { gql } from '@apollo/client';

export const createEventMutation = gql`
  mutation CreateEvent7($input: CreateEventInput!) {
    createEvent(input: $input) {
      event {
        id
      }
      errors {
        message
      }
    }
  }
`;

export const deleteEventMutation = gql`
  mutation DeleteEvent($input: DeleteEventInput!) {
    deleteEvent(input: $input) {
      event {
        id
      }
      errors {
        message
      }
    }
  }
`;

